import React from 'react';
import About from './About';
import Contact from './Contact';
import Category from './Category';
import MixPhotos from './MixPhotos';
import NotFound from './NotFound';
import {
    Switch,
    Route
  } from "react-router-dom";
import {Upload} from './Upload';


export default class ContentArea extends React.Component {

    render(){
        return (
            <Switch>
                <Route exact path="/">
                    <About />                    
                </Route>
                <Route path="/photos">
                    <MixPhotos />
                </Route>
                <Route path="/contact">
                    <Contact />
                </Route>
                <Route path="/categories">
                    <div id="categories">
                        <Category />
                    </div>
                </Route>
                <Route path="/rvuploadadmin">
                    <Upload />
                </Route>
                <Route component={NotFound} />

            </Switch>
        );
    }
}